module.exports = __webpack_public_path__ + "img/streamline-icon-add-circle@24x24.b6f119e0.svg";